import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { PayByLinkTechnicalError } from "@nju/feature-portal-payment";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function Payment() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <PayByLinkTechnicalError />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
